// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMenu_wrapper__38T-6","email":"UserMenu_email__338tM","button":"UserMenu_button__30Ycq"};